const styles = theme => ({
    dialog: {
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    grow: {
        flexGrow: 1,
    },
    selector: {
        position: 'relative'
    },
    videoPreview: {
        marginTop: '0',
        position: 'fixed',
        right: 0,
        bottom: 0,
        minWidth: '100%',
        minHeight: '100%',
        width: 'auto',
        height: 'auto'
    },
    flip: {
        transform: 'rotateY(180deg)',
        '-webkit-transform': 'rotateY(180deg)',
        '-moz-transform': 'rotateY(180deg)',
        position: 'relative'
    },
    bottomBar: {
        position: 'fixed',
        bottom: 0,
        top: 'unset',
        width: '100%',
        textAlign: 'center',
        backgroundColor: theme.palette.background.surface
    },
    devicePicker: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            paddingRight: theme.spacing(2)
        }
    },
    mirror: {
        marginLeft: 0,
        marginTop: '15px'
    },
    scanMessage: {
        marginTop: '250px',
    },
    targetOverlay: {
        zIndex: 100,
        border: `dashed 3px ${theme.palette.secondary.main}`,
        position: 'fixed',
        right: 48,
        top: 98,
        left: 48,
        bottom: 118,
        '@media (max-width:600px)': {
            bottom: 185
        },
        '@media (max-width:375px)': {
            bottom: 153,
            top: 73,
            left: 13,
            right: 13
        }
    },
    targetOverlayTop: {
        zIndex: 100,
        background: 'rgba(0,0,0,0.6)',
        position: 'fixed',
        right: 0,
        top: 0,
        left: 0,
        height: 100,
        '@media (max-width:375px)': {
            top: 0,
            height: 75,
            left: 0,
            right: 0
        }
    },
    targetOverlayLeft: {
        zIndex: 100,
        background: 'rgba(0,0,0,0.6)',
        position: 'fixed',
        top: 100,
        left: 0,
        width: 50,
        bottom: 75,
        '@media (max-width:375px)': {
            bottom: 125,
            top: 75,
            left: 0,
            width: 15
        }
    },
    targetOverlayRight: {
        background: 'rgba(0,0,0,0.6)',
        zIndex: 100,
        position: 'fixed',
        right: 0,
        width: 50,
        top: 100,
        bottom: 120,
        '@media (max-width:600px)': {
            bottom: 185
        },
        '@media (max-width:375px)': {
            bottom: 155,
            top: 75,
            width: 15,
            right: 0
        }
    },
    targetOverlayBottom: {
        zIndex: 100,
        background: 'rgba(0,0,0,0.6)',
        position: 'fixed',
        right: 0,
        height: 45,
        left: 50,
        bottom: 75,
        '@media (max-width:600px)': {
            bottom: 125,
            height: 60
        },
        '@media (max-width:375px)': {
            bottom: 125,
            height: 30,
            left: 15,
            right: 0
        }
    },
});

export default styles;